// extracted by mini-css-extract-plugin
export default {"header":"CalendarHeader_header__ucF7H","arrowLeft":"CalendarHeader_arrowLeft__kJH5Y","arrowRight":"CalendarHeader_arrowRight__eSVa5"};